module.exports = false;



//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_library.js
// module id = 34
// module chunks = 0